import { useQuery } from '@tanstack/react-query';
import {
  fetchPublicFeatureFlags,
  isDivorceProductEnabled,
  PUBLIC_FEATURE_FLAGS_QUERY_KEY,
} from '@/lib/public-feature-flags';

/** Fail-closed: hidden until the public flag fetch returns true. */
export function useIsDivorceProductEnabled(): boolean {
  const query = useQuery({
    queryKey: PUBLIC_FEATURE_FLAGS_QUERY_KEY,
    queryFn: fetchPublicFeatureFlags,
  });
  return isDivorceProductEnabled(query.data);
}
